@if (assignments) {
  <rt-requisitions-team-container [assignments]="assignments" [requisitionId]="requisitionId" />
}
